<template>
	<div class="edc-modal">
		<SOSlotModal :modal-title="`Panduan menulis template`" :modal-id="modalId" @close="back">
			<template v-slot:modal-body>
				<div>
					<div class="toolbar m-d-16">
						<p class="m-d-0 f-16 f-c-black f-bold">Toolbar</p>
						<div class="f-14 f-regular f-c-black toolbar-collection">
							<div class=" d-flex m-t-8 m-d-8" style="align-items: center;">
								<diV class="icons">
									<IconBased :width="10" :height="12">
										<template v-slot:icons>
											<BoldText />
										</template>
									</IconBased>
								</diV>
								<div>
									<label class="m-d-0">Membuat teks menjadi <b>bold</b> (tebal)</label>
								</div>
							</div>
							<div class="separator-line"></div>
							<div class=" d-flex m-t-8 m-d-8" style="align-items: center;">
								<diV class="icons">
									<IconBased :width="6" :height="12">
										<template v-slot:icons>
											<ItalicText />
										</template>
									</IconBased>
								</diV>
								<div>
									<label class="m-d-0">Membuat teks menjadi <i>italic</i> (miring)</label>
								</div>
							</div>
							<div class="separator-line"></div>
							<div class=" d-flex m-t-8 m-d-8" style="align-items: center;">
								<diV class="icons" style="padding-left: 6px">
									<IconBased :width="22" :height="22">
										<template v-slot:icons>
											<PlusCircleRed />
										</template>
									</IconBased>
								</diV>
								<div>
									<label class="m-d-0">
										Menambahkan <span class="key-src">shortcode</span> (data dinamis).
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="preview m-d-16">
						<p class="m-d-0 f-16 f-c-black f-bold">Preview</p>
						<p class="m-d-0 f-14 f-c-black f-regular">
							Preview berfungsi untuk melihat seperti apa tampilan pesan di dalam WA. Klik tombol
							“Pratinjau” di sebelah kanan atas.
						</p>
					</div>
					<div class="reset-template m-d-16">
						<p class="m-d-0 f-16 f-c-black f-bold">Reset template</p>
						<p class="m-d-0 f-14 f-c-black f-regular">
							Gunakan apabila ingin mengembalikan ke template awal (default). Scroll hingga ke bagian
							bawah halaman, klik “Reset template”.
						</p>
					</div>
				</div>
			</template>
		</SOSlotModal>
	</div>
</template>
<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import IconBased from "@/modules/wa-autosender/components/iconPack/IconBased";
import PlusCircleRed from "@/modules/wa-autosender/components/iconPack/PlusCircleRed2222";
import BoldText from "@/modules/wa-autosender/components/iconPack/BoldText1012";
import ItalicText from "@/modules/wa-autosender/components/iconPack/ItalicText0612";

export default {
	name: "PanduanPenulisanWaBlast",
	components: {
		SOSlotModal,
		IconBased,
		PlusCircleRed,
		BoldText,
		ItalicText,
	},
	data() {
		return {
			backLink: "wa_autosender.detail_perangkat.daftar_oulet.edit_template",
			modalId: "modal-panduan-penulisan",
		};
	},
	beforeRouteLeave(to, from, next) {
		this.closeModal();
		next();
	},
	mounted() {
		$(`#${this.modalId}`).modal("show");
	},
	methods: {
		async back() {
			this.$router.back()
		},
		closeModal() {
			$(`#${this.modalId}`).modal("hide");
		},
	},
};
</script>

<style scoped>
.toolbar .toolbar-collection {
	border: 1px solid #ededed;
	box-sizing: border-box;
	border-radius: 8px;
	padding: 0px 8px;
}
.toolbar .icons {
	border: 1px solid #ededed;
	box-sizing: border-box;
	border-radius: 4px;
	height: 36px;
	width: 36px;
	padding-left: 13px;
	padding-top: 6px;
	margin-right: 12px;
}
</style>
